import { create } from 'zustand';

type SyncStatus = 'idle' | 'syncing' | 'success' | 'error';

interface SyncState {
  status: SyncStatus;
  lastSyncTime: Date | null;
  pendingOperations: number;
  error: string | null;
  
  // Actions
  setStatus: (status: SyncStatus) => void;
  setLastSyncTime: (time: Date | null) => void;
  setPendingOperations: (count: number) => void;
  setError: (error: string | null) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  status: 'idle',
  lastSyncTime: null,
  pendingOperations: 0,
  error: null,
  
  setStatus: (status) => set({ status }),
  setLastSyncTime: (time) => set({ lastSyncTime: time }),
  setPendingOperations: (count) => set({ pendingOperations: count }),
  setError: (error) => set({ error }),
}));
